import React, { FC } from 'react';
import styled from 'styled-components';

const buttonConfigs = {
  disabled: {
    backgroundColorTop: '#F4F4F4',
    backgroundColorBottom: '#ACACAC',
    backgroundColorLight: '#ECECEC',
  },
  primary: {
    backgroundColorTop: '#9DCFF3',
    backgroundColorBottom: '#3B69B0',
    backgroundColorLight: '#9DCFF3',
    hover: {
      backgroundColorBottom: '#18407E',
    },
  },
  secondary: {
    backgroundColorTop: '#F8BC57',
    backgroundColorBottom: '#DC9122',
    backgroundColorLight: '#F8BC57',
    hover: {
      backgroundColorTop: '#DC9122',
      backgroundColorBottom: '#C48321',
    },
  },
  success: {
    backgroundColorTop: '#A2C038',
    backgroundColorBottom: '#93B226',
    backgroundColorLight: '#BCDE44',
    hover: {
      backgroundColorBottom: '#78911E',
    },
  },
};

const StyledButton: { [key: string]: any } = (() => {
  const res = {};
  Object.keys(buttonConfigs).map((key) => {
    res[key] = styled.button`
      background: linear-gradient(
        to bottom,
        ${buttonConfigs[key].backgroundColorTop} -100%,
        ${buttonConfigs[key].backgroundColorBottom} 120%
      );
      color: #ffffff;
      padding: 0.625rem 1.5rem;
      min-width: 13.25rem;
      border: 7.5px solid ${buttonConfigs[key].backgroundColorLight};
      display: inline-flex;
      flex-direction: row;
      font-weight: 700;
      justify-content: center;
      align-items: center;

      cursor: pointer;

      &:hover {
        @media (pointer: fine) {
          background: linear-gradient(
            to bottom,
            ${buttonConfigs[key].hover?.backgroundColorTop || buttonConfigs[key].backgroundColorTop} -100%,
            ${buttonConfigs[key].hover?.backgroundColorBottom || buttonConfigs[key].backgroundColorBottom} 120%
          );
        }
      }
    `;
  });
  return res;
})();

interface Props {
  type?: 'primary' | 'secondary' | 'success';
  style?: React.CSSProperties;
  disabled?: boolean;
  onClick?: (event: React.FormEvent<HTMLButtonElement>) => void;
}

export const Button: FC<Props> = (props) => {
  const type = props.type || 'primary';
  const disabled = props.disabled === true;
  const ButtonComponent = StyledButton[disabled ? 'disabled' : type];

  return (
    <ButtonComponent
      className={disabled ? 'not-clickable' : ''}
      style={{ ...props.style }}
      type="button"
      disabled={disabled}
      onClick={(event: React.FormEvent<HTMLButtonElement>) => {
        if (props.onClick) {
          props.onClick(event);
        }
      }}
    >
      {props.children}
    </ButtonComponent>
  );
};
